import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getFeaturedProperties } from '../Redux/Slices/PropertySlice';
import { useDispatch, useSelector } from 'react-redux';
import FeaturedpropertyList from '../Common/FeaturedpropertyList';

function FeaturedProperty() {


  const settings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userId = localStorage.getItem("userId");

  const feturedProperties = useSelector((state) => state.userProperty.FeaturedProperties);
  console.log("feturedProperties",feturedProperties)

  useEffect(() => {
    dispatch(getFeaturedProperties(userId));
  }, [userId]);


  return (
    <>
    {feturedProperties?.length == 0 ?
      null
      : 
    <section class="main-people-living">
      <section class="people-living mb-5 ">
        <div class="container">
          <div class="people-living-text pt-5 d-sm-flex justify-content-between mb-4">
            <div>
              <h5>Featured Properties</h5>
            </div>
            <div>
            </div>
          </div>
          
          <FeaturedpropertyList settings={settings} FeturedProperties={feturedProperties}/>
       
        </div>
      </section>
    </section>
    }
    </>
  )
}

export default FeaturedProperty